"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

var shapeGridMedia = (0, _propTypes.shape)({
  xs: _propTypes.string,
  md: _propTypes.string
});
var propTypes = {
  options: (0, _propTypes.shape)({
    gridAreas: shapeGridMedia,
    gridColumns: shapeGridMedia,
    gridRows: shapeGridMedia,
    gridJustifyItems: _propTypes.string,
    gridJustifyContent: _propTypes.string,
    gridAlignItems: _propTypes.string,
    gridAlignContent: _propTypes.string,
    gridRowGap: shapeGridMedia,
    gridColumnGap: shapeGridMedia,
    gridPadding: (0, _propTypes.arrayOf)(_propTypes.string)
  })
};
var defaultProps = {
  component: 'div'
};
var enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes, defaultProps));
var element = enhancer(function (props) {
  var withRef = props.withRef,
      component = props.component,
      className = props.className,
      dataTestId = props['data-testid'],
      options = props.options,
      other = _objectWithoutProperties(props, ["withRef", "component", "className", "data-testid", "options"]);

  return (0, _core.jsx)(_components.Grid, (0, _extends2["default"])({
    as: component,
    ref: withRef,
    className: className,
    "data-testid": dataTestId,
    options: options
  }, other));
});
exports.Grid = element;